import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('instructorstudentnotesview').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithType(type) {
	const { data, error } = await supabase.from('instructorstudentnotesview').select().eq('type', type)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('instructorstudentnotesview').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const prm = `studentId.eq.${id},studentId.is.null`
	const { data, error } = await supabase.from('instructorstudentnotesview').select().or(prm)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getInstructorStudent(id) {
	const { data, error } = await supabase.from('instructorstudentnotesview').select().or(`instructorId.eq.${id},subinstructorId.eq.${id}`)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('instructorstudentnotesview').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	console.log('udata', udata)
	const { data, error } = await supabase.from('instructorstudentnotesview').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('instructorstudentnotesview').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
